import ReactWidget from 'react-widget';
import { React } from 'vendor-react';

import SelectInput from '../../../modules/react-forms/scripts/Components/SelectInput';

export default class Widget extends ReactWidget {
    constructor(props) {
        super(props);

        const options = this.getStringPreference("options") ? JSON.parse(this.getStringPreference("options")) : []
        // ADD VALUE PROPERTY SAME AS URL
        options.forEach((element) => {
            element.value = element.url;
        });

        const selectedElement = this.getSelectedElement(options)
        this.state = {
            url: selectedElement && selectedElement.url,
            options: options,
            selectedTitle: selectedElement && selectedElement.label,
        };

        this.default_url = this.getStringPreference("defaultMicrositeUrl")
        this.placeholder = " "

    }
    componentDidUpdate(){
        this.sendLoadedDom()
    }

    sendLoadedDom() {
        // to trigger loaded dom
        const loadedNavtool = new CustomEvent('loadedNavtool', {});
        window.dispatchEvent(loadedNavtool)
    }

    componentDidMount(){
        let inserted = false
        let localThis = this

        App.PubSub.publish('recalculateTopNavPadding');
        this.sendLoadedDom();

        function displaySideNavTool() {
            if($(".top-navigation__menu-toggle").css("display") !== 'none') {
                $(".navtool-container").css("display", "none");
                const title = localThis.state.selectedTitle
                const options = localThis.state.options
                if(!inserted) {
                    createLinksForMobileViewsSimple(options, title)
                    inserted = true;
                } else {
                    $("#navtool-in-mobile").css("display", "initial");
                }
            }
            else {
                $(".navtool-container").css("display", "flex");
                if(inserted) {
                    $("#navtool-in-mobile").css("display", "none");
                }
            }
        }

        // CODE FOR MOBILE THAT HAS DROPDOWN BUT NOT CLICKABLE LINK
        function createLinksForMobileView(options, title) {
            var items = "";
            options.forEach((option, index) => {
                let headerNodes = '';
                option.headers.forEach((header) => {
                    headerNodes += `
                    <a
                        href="${header.url}"
                        class="top-navigation__level-3__section-link" target="_blank"
                    >
                        ${header.label}
                    </a>
                `;
                })
                items += `
                    <li class="has-children top-navigation__level-2__item" id="link-li-id-${index}">
                        <a
                            href="${option.url}"
                            style="white-space: nowrap;"
                            class="top-navigation__level-2__link js-level2-item ext_link"
                        >
                            ${option.label}
                        </a>
                        <div class="top-navigation__level-3">
                            <div class="top-navigation__container">
                                ${headerNodes}
                            </div>
                        </div>
                    </li>
                `;
            });
            var htmlNode = `
                <li class="top-navigation__level-1__item has-children for-dropdown" id="navtool-in-mobile">
                    <a class="top-navigation__level-1__link ext_link">You are in&nbsp;<span>${title}</span></a>
                    <div class="top-navigation__level-1__children_mobile js-mobile-children">
                        <div class="top-navigation__level-2">
                            <ul class="top-navigation__level-2__list">
                                ${items}
                            </ul>
                        </div>
                    </div>
                </li>`;
    
            $(".top-navigation__level-1__list").prepend(htmlNode);
            $("#navtool-in-mobile").click(() => {
                $("#navtool-in-mobile").toggleClass("active");
            });
            options.forEach((option, index) => {
                const id = `#link-li-id-${index}`;
                $(id).click((event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    $(id).toggleClass('open');
                })
            });
        }

        // CODE FOR MOBILE THAT HAS DROPDOWN BUT NOT CLICKABLE LINK
        function createLinksForMobileViewsSimple(options, title) {
            if (!window.location.href.includes(localThis.default_url)) {
                var items = "";
                options.forEach((option, index) => {
                    items += `<li class="top-navigation__level-2__item" id="link-li-id-${index}">
                        <a href="${option.url}" style="white-space: nowrap;" class="top-navigation__level-2__link js-level2-item ext_link">${option.label}</a>    
                    </li>`;
                });

                var htmlNode = `
                <li class="top-navigation__level-1__item has-children" id="navtool-in-mobile">
                    <a href="http://" class="top-navigation__level-1__link ext_link" target="_blank" data-toggle="" data-target="">You are in <span>${title}</span></a>
                    <div class="top-navigation__level-1__children_mobile js-mobile-children">
                        <div class="top-navigation__level-2">
                            <ul class="top-navigation__level-2__list">
                                ${items}
                            </ul>
                        </div>
                    </div>
                </li>`;

                $(".top-navigation__level-1__list").prepend(htmlNode);
                $("#navtool-in-mobile").click(() => {
                    event.preventDefault();
                    event.stopPropagation();
                    $("#navtool-in-mobile").toggleClass("active");
                });
                options.forEach((option, index) => {
                    const id = `#link-li-id-${index}`;
                    $(id).click(() => {
                        window.open(option.url,"_self");
                    })
                });
            }
        }

        // TO HIDE AND SHOW THE NAVTOOL UPON SCROLL
        window.onscroll = function() {scrollFunction()};
        function scrollFunction() {
            const scrollYPosition = document.body.scrollTop || document.documentElement.scrollTop;
            const clientWidth = document.body.clientWidth || document.documentElement.clientWidth;
            
            if (scrollYPosition > 50 && $(".top-navigation__menu-toggle").css("display") === 'none') {
                $(".navtool-container").css("display", "none");
            } else if ((scrollYPosition < 10) && $(".top-navigation__menu-toggle").css("display") === 'none'){
                $(".navtool-container").css("display", "flex");
            }
        }

        displaySideNavTool()
        window.addEventListener('resize', () => {
            displaySideNavTool()
        });
    }

    

    // FIND THE SELECTED JSON
    getSelectedElement(options){
        const currentURL = window.location.href
        let selectedElement = options.find(this.checkingOfURL(currentURL));

        if (selectedElement) {
            return selectedElement
        } else {
            return selectedElement = options.find((element) => {
                return element.headers.find(this.checkingOfURL(currentURL));
            });
        }

    }

    // currying
    // TO GET THE VALID URL
    checkingOfURL (currentURL) {
        return (element) => {
            // checking of the URL in the JSON
            const urlCheck = currentURL.includes(element.url)
            if ( urlCheck ) {
                if (element.url == ""){
                    return false
                } else {
                    return urlCheck
                }
            }
            else if (element.friendlyURL == ""){ // checking of the Friendly URL in the JSON
                return false
            } else {
                return currentURL.includes(element.friendlyURL)
            }
        }
    }

    // ON BUTTON CLICK TO CHANGE THE CURRENT SITE
    onChangeValue(url) {
        //this.setState({url: url});
        window.open(url,"_self");
    }

    // SHOWING THE RIGHT SIDE HEADERS
    showHeaders(){
        let headerContent = this.state.options.find(element => element.url === this.state.url)

        if(headerContent){
            return headerContent.headers.map( (home,index) => 
                <a key={index} className="navtool-a-link" href={home.url}>
                    {home.label}
                </a>
            )
        }
        return null
    }

    // TO SHOW IF THE 'YOU ARE IN' AT THE RIGHT SIDE
    showSelect() {
        if (window.location.href.includes(this.default_url)) {
            return null;
        }
        return [
            <div key="0" className="navtool-label">
                You are in
            </div>,
            <div key="1" className="navtool-select">
                <SelectInput
                    options={this.state.options}
                    placeholder={this.placeholder}
                    value={this.state.url}
                    onChange={this.onChangeValue.bind(this)}
                />
            </div>
        ];
    }

    render() {
        if (this.state.url === undefined || this.state.options===[]){
            return "";
        }
        return (
            <div className="navtool-container wide-container">
                <div className="navtool-left-div">
                    {this.showSelect()}
                </div>
                <div className="navtool-header">
                    {this.showHeaders()}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./collection-institutional-portal/src/widgets/widget-navigation-tool/scripts/index.js